import request from "@/router/axios";

export function getList(params) {
  return request({
    url: "/api/produce/coal-overstock-warning/select/page",
    method: "post",
    data: params,
  });
}

export function getSlowSaleConfig() {
  return request({
    url: "/api/produce/coal-overstock-warning/config/slow-sale-config",
    method: "post",
  });
}

export function getStatistics(params) {
  return request({
    url: "/api/produce/coal-overstock-warning/slow-sale/statistics",
    method: "post",
    data: params,
  });
}

export function releaseAlarm(params) {
  return request({
    url: "/api/produce/coal-overstock-warning/slow-sale/release",
    method: "post",
    data: params,
  });
}

export function exportExcel(params) {
  return request({
    url: "/api/produce/coal-overstock-warning/export/excel",
    method: "post",
    data: params,
    responseType: "blob",
  });
}

export function getCustomerOptions(deptName) {
  return request({
    url: "/api/produce/blade-dept/select/distinct/select",
    method: "get",
    params: deptName ? { deptName } : {},
  });
}

export function getCargoOptions(varName) {
  return request({
    url: "/api/produce/vardict/select/distinct/pycode",
    method: "get",
    params: varName ? { varName } : {},
  });
}

export function getCoalTypes(params) {
  return request({
    url: "/api/produce/coal-overstock-warning/select/coal-types",
    method: "get",
    params,
  });
}
